/* DOCS
	https://www.lightgalleryjs.com/docs/settings/
*/
/*
License:
	https://app.lemonsqueezy.com/my-orders/d7b1d905-5ef3-4892-b4c1-6b3adb8615ab?signature=189510b1e35103aaa52af7ba09ad0e70cc67111d190142d3c4f8d9b97611ccc0
	https://app.lemonsqueezy.com/magiclink/a2c567be-77fc-44ef-a886-714df011a6ee%3A0N2qViFne2lXQhTfY4jGds6Ew2YMm7lp3Kr9cRsbnMmG8KpOMyaVnFxPXAefXVEf
*/
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay';
import lgComment from 'lightgallery/plugins/comment';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgHash from 'lightgallery/plugins/hash';
import lgMediumZoom from 'lightgallery/plugins/mediumZoom'
import lgPager from 'lightgallery/plugins/pager';
import lgRelativeCaption from 'lightgallery/plugins/relativeCaption';
import lgRotate from 'lightgallery/plugins/rotate';
import lgShare from 'lightgallery/plugins/share';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgVimeoThumbnail from 'lightgallery/plugins/vimeoThumbnail';

const galleryItems = document.querySelectorAll('.gallery-item');
if (galleryItems.length > 0) {
	galleryItems.forEach(galleryItem => {
		lightGallery(galleryItem, {
			speed: 500,
			//plugins: [lgZoom, lgAutoplay, lgComment, lgFullscreen, lgHash, lgPager, lgRotate, lgShare, lgThumbnail, lgVideo]
			plugins: [lgZoom, lgAutoplay, lgFullscreen, lgHash, lgPager, lgThumbnail, lgVideo],
			licenseKey: 'B71729EB-4013-474E-BA3D-3647E23B4360',
			selector: 'this',
		});
	})
}
const galleries = document.querySelectorAll('.gallery');
if (galleries.length > 0) {
	galleries.forEach(gallery => {
		lightGallery(gallery, {
			speed: 500,
			//plugins: [lgZoom, lgAutoplay, lgComment, lgFullscreen, lgHash, lgPager, lgRotate, lgShare, lgThumbnail, lgVideo]
			plugins: [lgZoom, lgAutoplay, lgFullscreen, lgHash, lgPager, lgThumbnail, lgVideo],
			licenseKey: 'B71729EB-4013-474E-BA3D-3647E23B4360',
			selector: 'a[data-sub-html]',
		});
	})
}
